import { createContext } from "reka-ui";
import type { Ref } from "vue";

export const [useBugReportDialog, provideBugReportDialogContext] =
  createContext<{
    open: Ref<boolean>;
  }>("BugReport");
